import React from 'react';
import classNames from 'classnames/bind';

import { IconType } from 'types/icon';

import { Pill, PillIntent } from 'components/Pill/Pill';

import styles from './ComparePlansView.module.scss';

const c = classNames.bind(styles);

export type ComparePlansListItemProps = {
  children?: React.ReactNode;
};

type Variant = {
  icon: IconType;
  intent: PillIntent;
  excluded?: boolean;
  addOn?: boolean;
};

const DEFAULT_VARIANT: Variant = { icon: 'check', intent: 'info' };

const VARIANTS: Record<'+' | '-', Variant> = {
  '+': { icon: 'plus', intent: 'success', addOn: true },
  '-': { icon: 'cancel', intent: 'danger', excluded: true },
};

function resolveVariant(children: React.ReactNode): {
  variant: Variant;
  children: React.ReactNode;
} {
  if (typeof children !== 'string') {
    return { variant: DEFAULT_VARIANT, children };
  }

  const prefix = children[0];
  if (prefix === '+' || prefix === '-') {
    return {
      variant: VARIANTS[prefix],
      children: children.slice(1).trimStart(),
    };
  }

  return { variant: DEFAULT_VARIANT, children };
}

export function ComparePlansListItem({ children }: ComparePlansListItemProps) {
  const { variant, children: content } = resolveVariant(children);

  return (
    <li
      className={c('compare-item', {
        'compare-item-excluded': variant.excluded,
      })}
    >
      <Pill
        className={c('compare-item-bullet')}
        icon={variant.icon}
        intent={variant.intent}
        size="small"
      />
      <div className={c('compare-item-content')}>
        <span>
          {content}
          {variant.addOn && (
            <>
              {' '}
              <Pill
                className={c('compare-item-tag')}
                intent="success"
                size="small"
              >
                Add-on
              </Pill>
            </>
          )}
        </span>
      </div>
    </li>
  );
}
